import { render, staticRenderFns } from "./ClubSettings.vue?vue&type=template&id=1cdb6d63&scoped=true"
import script from "./ClubSettings.vue?vue&type=script&lang=js"
export * from "./ClubSettings.vue?vue&type=script&lang=js"
import style0 from "./ClubSettings.vue?vue&type=style&index=0&id=1cdb6d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb6d63",
  null
  
)

export default component.exports